import { orderStatusFilterTextToBackendStatus, type BlotterTableFilter } from '@talos/kyoko';
import { pick } from 'lodash-es';
import type { BlotterTableOrderFilter } from './useOrderFilter';

const SERVER_FILTER_KEYS: (keyof BlotterTableOrderFilter)[] = [
  'TimestampField',
  'StartDate',
  'EndDate',
  'Statuses',
  'SubAccounts',
  'Symbols',
  'HideApiCalls',
  'OrderID',
  'RFQID',
  'ClOrdID',
  'ParentOrderID',
  'ParentRFQID',
];

export function toOrdersServerFilter(filter: BlotterTableOrderFilter | undefined): BlotterTableFilter | undefined {
  if (!filter) {
    return filter;
  }

  const serverFilter = pick(filter, SERVER_FILTER_KEYS);
  if (filter._statuses) {
    serverFilter.Statuses = orderStatusFilterTextToBackendStatus(filter._statuses);
  }

  return serverFilter;
}
